





















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
})
export default class SairamCard extends Vue {

  @Prop() readonly totalPago!: number;
  @Prop() date!: string | null;
  @Prop() readonly sairam!: number;
  @Prop() readonly loading!: boolean;
  mesAtual: string | null = null;
}
